import React, { FunctionComponent, useCallback } from "react";
import { GenericViewer } from "../../GenericViewer/GenericViewer";
import { TimelineItem } from "../../../../../store/timelines/types";
import { ContentFailureCallback, ContentFailureGenericCb } from "../types";

export interface SlotContentProps {
  item: TimelineItem;
  isPreload: boolean;
  onContentFailure: ContentFailureCallback;
  timelineItemIndex: number; // index of the item in the timeline items array
}

export const SlotContent: FunctionComponent<SlotContentProps> = (props) => {
  const { item, timelineItemIndex, onContentFailure, isPreload } = props;

  const onContentFailureCb = useCallback<ContentFailureGenericCb>(() => {
    return onContentFailure(timelineItemIndex);
  }, [onContentFailure, timelineItemIndex]);

  return (
    <GenericViewer
      contentItem={item}
      isPreload={isPreload}
      itemStartTimestamp={item.startTimestampMs}
      onContentFailure={onContentFailureCb}
    />
  );
};
